module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/carousel/carousel-create/carousel-create.component.scss
// module id = ./src/app/carousel/carousel-create/carousel-create.component.scss
// module chunks = main